"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogger = exports.json = void 0;
var loglevel_1 = __importDefault(require("loglevel"));
var loglevel_plugin_remote_1 = __importDefault(require("loglevel-plugin-remote"));
var json = function (log) {
    log.level = log.level.label;
    log.version = window.ApplicationLoggerSettings && window.ApplicationLoggerSettings.version ? window.ApplicationLoggerSettings.version : "unknown";
    log.origin = window.location.origin;
    log.agent = navigator.userAgent;
    log.width = window.outerWidth;
    log.height = window.outerHeight;
    log.hash = window.location.hash;
    log.path = window.location.pathname;
    return log;
};
exports.json = json;
var defaults = {
    url: process.env.REACT_APP_LOGGING || 'https://logging.serverless.p2g.systems/Prod/logging',
    method: 'POST',
    timeout: 0,
    interval: 1000,
    level: window.ApplicationLoggerSettings && window.ApplicationLoggerSettings.level ? window.ApplicationLoggerSettings.level : "trace",
    backoff: {
        multiplier: 2,
        jitter: 0.1,
        limit: 30000,
    },
    capacity: 500,
    stacktrace: {
        levels: ['warn', 'error'],
        depth: 3,
        excess: 0,
    },
    timestamp: function () { return new Date().toISOString(); },
    format: exports.json
};
loglevel_plugin_remote_1.default.apply(loglevel_1.default, defaults);
var getLogger = function () {
    var logger = loglevel_1.default.getLogger(window.ApplicationLoggerSettings && window.ApplicationLoggerSettings.name ? window.ApplicationLoggerSettings.name : window.location.hostname);
    logger.setLevel(window.ApplicationLoggerSettings && window.ApplicationLoggerSettings.level ? window.ApplicationLoggerSettings.level : "trace");
    return logger;
};
exports.getLogger = getLogger;
